import { MarketLabel } from '@/types';

const isFavoriteMarket = (market: MarketLabel): boolean => {
	return market === 'favorite';
};

const isOutrightMarket = (market: MarketLabel): boolean => {
	return market === 'outright';
};

const isOutrightBySport = (sport: number) => {
	return sport === 999;
};

const isOutrightByBetType = (betType: string | number) => {
	return Number(betType) === 10;
};

export const marketService = {
	isFavoriteMarket,
	isOutrightMarket,
	isOutrightBySport,
	isOutrightByBetType
};